import { MobileSliderPagesStyled } from "./styled/MobileSliderPagesStyled.js";

function MobileSliderPagesWrapper(props) {
    const {backgroundColor, children, className} = props;
    return <MobileSliderPagesStyled backgroundColor={backgroundColor} className={className}>
        {children}
    </MobileSliderPagesStyled>
}

export default MobileSliderPagesWrapper;
